import { useUser } from "../contexts/UserContext";

export const useProfile = (profileId) => {
  const { user } = useUser();

  if (user.helper) {
    return user.helper.profile;
  }

  if (!profileId) {
    return null;
  }

  if (!user.customer.profiles) {
    return null;
  }

  const profile = user.customer.profiles.find((p) => p._id === profileId);

  return profile || null;
};
